import DefaultLayout from '../layouts/defaultLayout';
import { Box, Button, Typography } from '@mui/material';

const categories = [
  { title: 'ios/ Monthly', price: 3 },
  { title: 'ios/ Annual', price: 20 },
  { title: 'Android/ Monthly', price: 3 },
  { title: 'Android/ Annual', price: 15 }
];

export default function Price() {
  return (
    <DefaultLayout>
      <Box display="flex" flexDirection="column" gap={3}>
        <Typography color="primary.main" variant="h4" fontWeight={400}>
          Price
        </Typography>
        <Box
          width="100%"
          flexDirection={{ xs: 'column', sm: 'row' }}
          display="flex"
          alignItems="center"
          gap={3}>
          {[...categories].slice(0, 2).map(({ title, price }) => (
            <Box
              flex={1}
              width="100%"
              maxWidth={{ xs: '100%', sm: '300px' }}
              display="flex"
              flexDirection="column"
              gap={2}>
              <Typography fontWeight={400} variant="h5">
                {title}
              </Typography>
              <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="primary.main"
                padding={5}>
                <Typography fontWeight={400} variant="h3" color="white">
                  {price}$
                </Typography>
              </Box>
              <Button sx={{ color: 'white' }} variant="contained" color="success">
                Update price
              </Button>
            </Box>
          ))}
        </Box>
        <Box
          flexDirection={{ xs: 'column', sm: 'row' }}
          width="100%"
          display="flex"
          alignItems="center"
          gap={3}>
          {[...categories].slice(2).map(({ title, price }) => (
            <Box
              width="100%"
              flex={1}
              maxWidth={{ xs: '100%', sm: '300px' }}
              display="flex"
              flexDirection="column"
              gap={2}>
              <Typography fontWeight={400} variant="h5">
                {title}
              </Typography>
              <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="primary.main"
                padding={5}>
                <Typography fontWeight={400} variant="h3" color="white">
                  {price}$
                </Typography>
              </Box>
              <Button sx={{ color: 'white' }} variant="contained" color="success">
                Update price
              </Button>
            </Box>
          ))}
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <Button variant="contained">Price history</Button>
        </Box>
      </Box>
    </DefaultLayout>
  );
}
